import { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import { HealthBadge } from "../components/HealthBadge";
import { TradeCard } from "../components/TradeCard";
import { readEditIntent } from "../lib/editIntent";

export function TradePage() {
  const location = useLocation();

  /**
   * Read once from router state: reading `location.state` on every render would
   * bring the edit banner back after the replacement went in.
   */
  const [editing, setEditing] = useState(() => readEditIntent(location.state));

  // Nothing on this page lists fills, so a submit has nothing here to refresh.
  const handleOrderSubmitted = useCallback(() => {}, []);

  const handleEditReplaced = useCallback(() => {
    setEditing(null);
  }, []);

  return (
    <div className="page page-trade">
      {/* The health badge sits under the headline: a diagnostic, not a title. */}
      <div className="hero">
        <h1 className="hero-title">
          Swap any local
          <br />
          stablecoin
        </h1>
        <HealthBadge />
      </div>

      <TradeCard
        onOrderSubmitted={handleOrderSubmitted}
        editing={editing}
        onEditReplaced={handleEditReplaced}
      />
    </div>
  );
}
